<!-- Spinner -->

<!-- Content -->
@if ({selectedNodes: (trainingSharedFacade.selectedNodesSet$ | async), selectedSlideNodes: (trainingSharedFacade.selectedSlideNodes$ | async), selectedNodeIndex: (trainingSharedFacade.selectedNodeIndex$ | async), slideResultsAvailable: (trainingSharedFacade.slideSelectionAvailable$ | async)}; as trainingData) {
  <div class="mdsf-slide-control">
    <!-- Position -->
    <span class="position">
      <input class="mdsf-slide-control_input"
        type="number"
        min="1"
        [max]="trainingData.selectedNodes.size"
        [value]="(trainingData.selectedNodeIndex || 0) + 1"
        (change)="trainingSharedFacade.requestGoToSlideByIndex($event.target, trainingData.selectedNodeIndex, trainingData.selectedNodes, trainingData.selectedSlideNodes, trainingData.slideResultsAvailable, route.snapshot.queryParams)">
      / {{ trainingData.selectedNodes.size }}
    </span>
    <!-- Progess Bar -->
    <div class="mdsf-progress">
      @for (selectedNode of trainingData.selectedNodes; track selectedNode; let i = $index) {
        @if ((trainingSharedFacade.node$(selectedNode) | async); as slide) {
          @if ((trainingSharedFacade.page$(slide.page) | async); as page) {
            @if (page !== null) {
              <div class="mdsf-progress-point"
                [class.current]="trainingData.selectedNodeIndex === i"
                [class.past]="trainingData.selectedNodeIndex > i"
                [class.available]="trainingData.slideResultsAvailable && trainingData.slideResultsAvailable[page.id] === true"
                [routerLink]="(trainingSharedFacade.slideUrlByNode$(slide) | async)"
                [queryParams]="route.snapshot.queryParams"
                placement="top"
                [ngbTooltip]="(i + 1) + ': ' + page.title">
                <div class="mdsf-progress-point-marker"></div>
              </div>
            }
          }
        }
      }
      <div class="mdsf-progress-wrap">
        <div class="mdsf-progress-bar"
          [class.transition-easeout]="true"
          [style.transform]="'scaleX(' + (trainingSharedFacade.selectedSlidePercentage$ | async) + ')'">
        </div>
      </div>
    </div>
    <!-- Previous -->
    @if ((trainingSharedFacade.previousSlideUrl$ | async); as previousUrl) {
      <button class="button mdsf-btn"
        type="button"
        role="button"
        [routerLink]="['/' + previousUrl]"
        [queryParams]="route.snapshot.queryParams">
        <span class="fa fa-chevron-left"></span>
      </button>
    }
    <!-- Next -->
    @if ({nextSlideNode: (trainingSharedFacade.nextSlideNode$ | async), nextUrl: (trainingSharedFacade.nextSlideUrl$ | async)}; as nextData) {
      <button class="button mdsf-btn next-btn"
        type="button"
        role="button"
        [disabled]="nextData.nextSlideNode && trainingData.slideResultsAvailable && trainingData.slideResultsAvailable[nextData.nextSlideNode.page] === false"
        [routerLink]="['/' + nextData.nextUrl]"
        [queryParams]="route.snapshot.queryParams">
        <span class="fa fa-chevron-right"></span>
      </button>
    }
  </div>
  <div class="mdsf-slide-button-group d-none d-md-inline-block">
    <div class="button mdsf-btn" (click)="feedbackControlService.openFeedbackModal()">
      <a>FEEDBACK</a>
    </div>
  </div>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
